import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

const Stars = ({ value, size = "w-4 h-4" }) => (
  <span className="inline-flex gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} className={`${size} ${n <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-muted-foreground/30"}`} />
    ))}
  </span>
);

export function RatingSummary() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/ratings/summary").then((r) => setD(r.data)).catch(() => setD({ count: 0, average: 0, distribution: {}, recent: [] })); }, []);
  if (!d) return null;
  return (
    <div className="border border-border bg-card rounded-sm" data-testid="rating-summary">
      <div className="px-6 py-4 border-b border-border flex items-center justify-between">
        <div className="overline text-muted-foreground">Rating Chat Nadia</div>
        <span className="text-xs text-muted-foreground" data-testid="rating-count">{d.count} penilaian</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6">
        <div>
          <div className="font-heading font-black text-4xl text-primary" data-testid="rating-average">{d.count ? d.average.toFixed(1) : "–"}</div>
          <Stars value={d.average} size="w-5 h-5" />
          <div className="mt-4 space-y-1.5">
            {[5, 4, 3, 2, 1].map((n) => {
              const c = d.distribution[n] || 0;
              return (
                <div key={n} className="flex items-center gap-2 text-xs" data-testid={`rating-dist-${n}`}>
                  <span className="w-3 text-muted-foreground">{n}</span>
                  <div className="flex-1 h-2 bg-secondary rounded-full overflow-hidden">
                    <div className="h-full bg-amber-400" style={{ width: `${d.count ? (c / d.count) * 100 : 0}%` }} />
                  </div>
                  <span className="w-6 text-right font-mono">{c}</span>
                </div>
              );
            })}
          </div>
        </div>
        <div className="md:col-span-2">
          <div className="text-xs font-semibold text-muted-foreground mb-2">Komentar terbaru</div>
          {d.recent.length === 0 && <div className="text-sm text-muted-foreground" data-testid="rating-empty">Belum ada rating dari pelanggan.</div>}
          <div className="divide-y divide-border">
            {d.recent.map((r) => (
              <div key={r.id} className="py-2.5" data-testid="rating-recent-item">
                <div className="flex items-center justify-between gap-3">
                  <span className="text-sm font-medium truncate">{r.customer_name}{r.customer_company ? ` · ${r.customer_company}` : ""}</span>
                  <Stars value={r.rating} size="w-3.5 h-3.5" />
                </div>
                <div className="text-sm text-muted-foreground">{r.rating_comment || <i>Tanpa komentar</i>}</div>
                <div className="font-mono text-[10px] text-muted-foreground/70">{r.case_number} · {(r.rated_at || "").slice(0, 10)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
